import React from 'react'
import contact from '../imgs/Frame 4605.png';
import heart from '../imgs/heart.png';
import people from '../imgs/people.png';
import Union from '../imgs/Union.png';
import Vector from '../imgs/Vector.png';
import run from '../imgs/run.png';
const WHAT_WE_DO = () => {
  return (
    <div className="relative bg-[#0B1D26] text-white h-auto overflow-hidden z-10 pt-[80px] pb-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start px-4 md:px-0">
          {/* LEFT: Content */}
          <div className="relative">
            {/* Tiêu đề WHAT WE DO */}
            <div className="relative h-[40px] flex items-center mb-4 w-full mt-[0px] md:mt-[20px] ml-4 md:ml-[50px]">
              {/* Chữ mờ lớn phía sau */}
              <h2 className="absolute text-[43px] md:text-[90px] font-bold text-white/5 uppercase leading-none z-0 select-none left-0">
                WHAT WE DO
              </h2>

              {/* Chữ nhỏ phía trước */}
              <div className="relative z-10 flex items-center space-x-3">
                <div className="w-[30px] h-0.5 bg-yellow-400"></div>
                <h3 className="text-yellow-400 uppercase tracking-widest text-[14px] md:text-[22px] font-semibold">
                  WHAT WE DO
                </h3>
              </div>
            </div>

            {/* Nội dung 4 cột */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-[50px] md:ml-[80px]">
              {/* Item 1 */}
              <div className="text-center flex flex-col items-center hover:scale-105 transition-transform duration-300 px-4 md:px-0">
                {/* Icon */}
                <img
                  src={heart}
                  alt="Hospitality"
                  className="w-[57px] h-[48px] md:w-[152px] md:h-[128px] mb-6"
                />

                {/* Tiêu đề */}
               
                <h4 className="text-white text-[18px] md:text-xl uppercase font-miller tracking-wide mb-4 leading-snug text-center ">
                  Hospitality consulting
                </h4>

                {/* Danh sách */}
                <ul className="text-sm list-disc list-outside pl-6 space-y-2 text-white text-left">
                  <li className="leading-relaxed">Conduct site survey and market research</li>
                  <li className="leading-relaxed">Suggest business model with general business plan</li>
                  <li className="leading-relaxed">Market feasibility analysis</li>
                </ul>
              </div>

              {/* Item 2 */}

              <div className="text-center flex flex-col items-center hover:scale-105 transition-transform duration-300">
                <img src={Union} alt="Architectural" className="w-[48px] h-[48px] md:w-[152px] md:h-[128px] mb-6" />
                <h4 className="text-white text-[18px] md:text-xl uppercase font-miller tracking-wide mb-4 leading-snug text-center ">
                  Architectural consulting
                </h4>
                <ul className="text-sm list-disc list-outside pl-6 space-y-2 text-white text-left">
                  <li className="leading-relaxed">Concept & Architectural design</li>
                  <li className="leading-relaxed">Fabricated housing & installation within project</li>
                  <li className="leading-relaxed">Assisting with construction & installation process</li>
                </ul>
              </div>

              {/* Item 3 */}
              <div className="text-center flex flex-col items-center hover:scale-105 transition-transform duration-300">
                <img src={people} alt="Business" className="w-[59px] h-[48px] md:w-[152px] md:h-[128px] mb-6" />
                <h4 className="text-white text-[18px] md:text-xl uppercase font-miller tracking-wide mb-4 leading-snug text-center md:text-left whitespace-nowrap md:whitespace-normal">
                  Business setup
                </h4>
                <ul className="text-sm list-disc list-outside pl-6 space-y-2 text-white text-left">
                  <li className="leading-relaxed">Brand build & strategy execution</li>
                  <li className="leading-relaxed">Facility & equipment installation</li>
                  <li className="leading-relaxed">Operation setup with recruitmet & staff training </li>
                </ul>
              </div>

              {/* Item 4 */}
              <div className="text-center flex flex-col items-center hover:scale-105 transition-transform duration-300">
                <img src={Vector} alt="Operation" className="w-[53px] h-[48px] md:w-[152px] md:h-[128px] mb-6" />
                <h4 className="text-white text-[18px] md:text-xl uppercase font-miller tracking-wide mb-4 leading-snug text-center md:text-left">
                  Operation
                </h4>
                <ul className="text-sm list-disc list-outside pl-6 space-y-2 text-white text-left">
                  <li className="leading-relaxed">Assest management & finacial service</li>
                  <li className="leading-relaxed">Execute daily operation to ensure KPIs ad maximize return on investment</li>
                  <li className="leading-relaxed">Develop & maintain add on services within project</li>
                </ul>
              </div>
            </div>
          </div>

          {/* RIGHT: Image */}
          <div className="hidden lg:flex justify-center lg:justify-end animate-fade-in-up">
            <img
              src={run}
              alt="What we do"
              className="rounded-2xl w-full max-w-md shadow-lg"
            />
          </div>
        </div>
      </div>
  )
}

export default WHAT_WE_DO